import ColorMixin from "@/mixins/ColorMixin";
const { AISEA_COLOR } = ColorMixin.data();

const COMPLETE = "COMPLETE"; // 完了
const IN_PROGRESS = "IN_PROGRESS"; // 要対応
const WAITING = "WAITING"; // 対応待ち
export const SITUATIONS = {
  IN_PROGRESS,
  WAITING,
  COMPLETE,
};

export const SITUATION_BADGE_STYLES = {
  [IN_PROGRESS]: {
    backgroundColor: AISEA_COLOR.RED,
    color: AISEA_COLOR.PURE_WHITE,
  },
  [WAITING]: {
    backgroundColor: "#E0F0FA",
    color: "#1B5E83",
  },
  [COMPLETE]: {
    backgroundColor: AISEA_COLOR.WHITE,
    color: AISEA_COLOR.DARK_GRAY,
  },
};

const ACCOUNT_NAME = "ACCOUNT_NAME";
const DEPARTMENT_NAME = "DEPARTMENT_NAME";
const SERVICE_NAME = "SERVICE_NAME";
const SITUATION = "SITUATION";
const UPDATED_AT = "UPDATED_AT";
const VESSEL_NAME = "VESSEL_NAME";
export const SORT_COLUMNS = {
  ACCOUNT_NAME,
  DEPARTMENT_NAME,
  SERVICE_NAME,
  SITUATION,
  UPDATED_AT,
  VESSEL_NAME,
};

const ASC = "ASC";
const DESC = "DESC";
export const SORT_ORDERS = {
  ASC,
  DESC,
};

const FIXED = "FIXED";
const DATE_PICKER = "DATE_PICKER";
const TIME_PICKER = "TIME_PICKER";
const SPACE = "SPACE";
const DATETIME_PICKER = "DATETIME_PICKER";
const SELECT = "SELECT";
const HIERARCHICAL_SELECT = "HIERARCHICAL_SELECT";
const CHECK_BOX = "CHECK_BOX";
const RADIO_BUTTON = "RADIO_BUTTON";
const NUMBER = "NUMBER";
const SHORT_TEXT = "SHORT_TEXT";
const LONG_TEXT = "LONG_TEXT";
const SINGLE_IMAGE_FILE = "SINGLE_IMAGE_FILE";
const SINGLE_OTHER_FILE = "SINGLE_OTHER_FILE";
const DATE_RANGE_PICKER = "DATE_RANGE_PICKER";
const DATE_MULTI_SELECT_FROM_RANGE = "DATE_MULTI_SELECT_FROM_RANGE";
const FLEXIBLE_TIME_PICKER = "FLEXIBLE_TIME_PICKER";
const PORT_HIERARCHY_PICKER = "PORT_HIERARCHY_PICKER";
const CARGO_PICKER = "CARGO_PICKER";
const BINDING = "BINDING";
export const INPUT_TYPES = {
  FIXED,
  DATE_PICKER,
  TIME_PICKER,
  SPACE,
  DATETIME_PICKER,
  SELECT,
  HIERARCHICAL_SELECT,
  CHECK_BOX,
  RADIO_BUTTON,
  NUMBER,
  SHORT_TEXT,
  LONG_TEXT,
  SINGLE_IMAGE_FILE,
  SINGLE_OTHER_FILE,
  DATE_RANGE_PICKER,
  DATE_MULTI_SELECT_FROM_RANGE,
  FLEXIBLE_TIME_PICKER,
  PORT_HIERARCHY_PICKER,
  CARGO_PICKER,
  BINDING,
};

export const INPUT_TYPE_ENUM = [
  INPUT_TYPES.FIXED, // 0: FIXED (固定値)
  INPUT_TYPES.DATE_PICKER, // 1: DATE_PICKER (年月日)
  INPUT_TYPES.TIME_PICKER, // 2: TIME_PICKER (時間)
  INPUT_TYPES.SPACE, // 3: SPACE（レイアウト調整用）
  INPUT_TYPES.DATETIME_PICKER, // 4: DATETIME_PICKER (日時)
  INPUT_TYPES.SELECT, // 5: SELECT (選択項目)
  INPUT_TYPES.HIERARCHICAL_SELECT, // 6: HIERARCHICAL_SELECT (２階層選択)
  INPUT_TYPES.CHECK_BOX, // 7: CHECK_BOX (チェックボックス)
  INPUT_TYPES.RADIO_BUTTON, // 8: RADIO_BUTTON (ラジオボタン)
  INPUT_TYPES.NUMBER, // 9: NUMBER (数値入力)
  INPUT_TYPES.SHORT_TEXT, // 10: SHORT_TEXT  (短いテキスト入力)
  INPUT_TYPES.LONG_TEXT, // 11: LONG_TEXT  (長いテキスト入力)
  INPUT_TYPES.SINGLE_IMAGE_FILE, // 12: SINGLE_IMAGE_FILE (1ファイル・画像アップロード、拡張子でプレビュー/ファイル表示を切り替え)
  INPUT_TYPES.SINGLE_OTHER_FILE, // 13: SINGLE_OTHER_FILE（1ファイル(画像以外)アップロード)
  INPUT_TYPES.DATE_RANGE_PICKER, // 14: DATE_RANGE_PICKER（日付範囲。value_json {start,end}）
  INPUT_TYPES.DATE_MULTI_SELECT_FROM_RANGE, // 15: DATE_MULTI_SELECT_FROM_RANGE（範囲内複数日。value_json [date,...]）
  INPUT_TYPES.FLEXIBLE_TIME_PICKER, // 16: FLEXIBLE_TIME_PICKER（AM/PM/未定/詳細時刻。value_string）
  INPUT_TYPES.PORT_HIERARCHY_PICKER, // 17: PORT_HIERARCHY_PICKER（港3階層。value_json・read-only）
  INPUT_TYPES.CARGO_PICKER, // 18: CARGO_PICKER（貨物3点。value_json・read-only）
  INPUT_TYPES.BINDING, // 19: BINDING（配船タブ直接列。レポート値なし）
];

// フォームバージョン項目グループ種別
const NORMAL = "NORMAL";
const TABLE = "TABLE";
export const GROUP_TYPES = {
  NORMAL, // 通常グループ（項目が縦に並ぶ）
  TABLE, // 表形式グループ（行と列のマトリクスで項目を配置）
};

export const REPORT_SEARCH_CONDITIONS_DOCUMENT_NAME =
  "report_search_conditions"; // 検索条件保存のドキュメント名
